import { DRAFT_MAIL } from "../apiConstant";
import BaseApi from "../baseApi";

class DraftMessageApi extends BaseApi {
  getMailDraft(conversationId) {
    return this.get(`${DRAFT_MAIL}/${conversationId}`);
  }

  createMailDraft(body) {
    return this.post(`${DRAFT_MAIL}/create-draft`, body);
  }

  schedule(body) {
    return this.post(`${DRAFT_MAIL}/schedule`, body);
  }

  createOrUpdate(body) {
    return this.post(`${DRAFT_MAIL}/send`, body);
  }

  delete(body) {
    return this.post(`${DRAFT_MAIL}/delete`, body);
  }
}

export default DraftMessageApi;
